<!--ABOUTME: The full Gotoko wordmark, switching to its light variant in dark mode-->
<!--ABOUTME: so the dark "GTK" letters stay legible on dark surfaces-->

<template>
    <component :is="darkMode ? GotokoLogoLight : GotokoLogoDark" />
</template>

<script setup lang="ts">
import GotokoLogoLight from "@/assets/gotoko-logo-light.svg?component";
import GotokoLogoDark from "@/assets/gotoko-logo.svg?component";
import { useUIManager } from "@/stores/ui-store";

const { darkMode } = useUIManager();
</script>
